import { createRouter, createWebHistory } from 'vue-router'
import { APP_BASE } from '../utils/appBase'
import Layout from '../views/Layout.vue'
import Dashboard from '../views/Dashboard.vue'
import Generation from '../views/Generation.vue'
import History from '../views/History.vue'
import Tasks from '../views/Tasks.vue'
import PublishGateway from '../views/PublishGateway.vue'
import Prompts from '../views/Prompts.vue'
import PromptLab from '../views/PromptLab.vue'
import Settings from '../views/Settings.vue'
import ZhihuQa from '../views/ZhihuQa.vue'
import Tabstory from '../views/Tabstory.vue'
import BilibiliRewrite from '../views/BilibiliRewrite.vue'
import Rewrite from '../views/Rewrite.vue'
import DouyinRewrite from '../views/DouyinRewrite.vue'
import ColumnOral from '../views/ColumnOral.vue'
import DataAnalytics from '../views/DataAnalytics.vue'
import XhsAccountBoard from '../views/XhsAccountBoard.vue'
import XhsNoteBoard from '../views/XhsNoteBoard.vue'
import Voice2Video from '../views/Voice2Video.vue'
import XhsNoteDiscovery from '../views/XhsNoteDiscovery.vue'
import DiscoveryLibrary from '../views/DiscoveryLibrary.vue'
import XhsCommentMonitor from '../views/XhsCommentMonitor.vue'
import DouyinDiscovery from '../views/DouyinDiscovery.vue'
import CreateStudio from '../views/CreateStudio.vue'
import CreateHome from '../views/CreateHome.vue'
import RewriteHub from '../views/RewriteHub.vue'
import SectionHub from '../components/shell/SectionHub.vue'
import ContentOpsAgent from '../views/ContentOpsAgent.vue'
import ContentOpsWorkbench from '../views/ContentOpsWorkbench.vue'
import ContentOpsCalendar from '../views/ContentOpsCalendar.vue'
import DevicesSettings from '../views/DevicesSettings.vue'
import TopicPoolSettings from '../views/TopicPoolSettings.vue'
import SmsGateway from '../views/SmsGateway.vue'

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      { path: '', name: '工作台', component: Dashboard },

      // 创作：入口页选择创作方式
      {
        path: 'create',
        component: CreateStudio,
        children: [
          { path: '', name: '创作', component: CreateHome },
          { path: 'generate', name: '批量生成', component: Generation },
          { path: 'zhihu-qa', name: '知乎问答', component: ZhihuQa },
          { path: 'column-oral', name: '专栏口播', component: ColumnOral },
          { path: 'voice2video', name: '口播转视频', component: Voice2Video },
          { path: 'tabstory', name: 'Tabstory', component: Tabstory },
          {
            path: 'rewrite',
            component: RewriteHub,
            children: [
              { path: '', redirect: { name: 'B站洗稿' } },
              { path: 'bilibili', name: 'B站洗稿', component: BilibiliRewrite },
              { path: 'douyin', name: '抖音洗稿', component: DouyinRewrite },
              { path: 'text', name: '文本洗稿', component: Rewrite },
            ],
          },
        ],
      },

      // 内容（库 / 任务 / 草稿 / 日历）
      {
        path: 'content',
        component: SectionHub,
        props: { sectionKey: 'content' },
        children: [
          { path: '', redirect: { name: '内容库' } },
          { path: 'library', name: '内容库', component: History },
          { path: 'tasks', name: '生成任务', component: Tasks },
          { path: 'workbench', name: '待处理草稿', component: ContentOpsWorkbench },
          { path: 'calendar', name: '内容日历', component: ContentOpsCalendar },
        ],
      },

      { path: 'publish', name: '发布中心', component: PublishGateway },
      { path: 'sms', redirect: { path: '/publish', query: { tab: 'sms' } } },
      { path: 'data-analytics', name: '数据中心', component: DataAnalytics },
      {
        path: 'data-analytics/xhs/group/:groupId',
        name: '小红书分组看板',
        component: () => import('../views/XhsGroupBoard.vue'),
      },
      {
        path: 'data-analytics/douyin/group/:groupId',
        name: '抖音分组看板',
        component: () => import('../views/DouyinGroupBoard.vue'),
      },
      {
        path: 'data-analytics/zhihu/group/:groupId',
        name: '知乎分组看板',
        component: () => import('../views/ZhihuGroupBoard.vue'),
      },
      {
        path: 'data-analytics/toutiao/group/:groupId',
        name: '头条分组看板',
        component: () => import('../views/ToutiaoGroupBoard.vue'),
      },
      {
        path: 'data-analytics/baijiahao/group/:groupId',
        name: '百家号分组看板',
        component: () => import('../views/BaijiahaoGroupBoard.vue'),
      },
      {
        path: 'data-analytics/group/:groupId',
        name: '分组看板',
        component: () => import('../views/MatrixGroupBoard.vue'),
      },
      {
        path: 'data-analytics/zhihu/:accountId',
        name: '知乎账号看板',
        component: () => import('../views/ZhihuAccountBoard.vue'),
      },
      {
        path: 'data-analytics/douyin/:accountId',
        name: '抖音账号看板',
        component: () => import('../views/DouyinAccountBoard.vue'),
      },
      {
        path: 'data-analytics/douyin/:accountId/works/:itemId',
        name: '抖音作品看板',
        component: () => import('../views/DouyinWorkBoard.vue'),
      },
      {
        path: 'data-analytics/toutiao/:accountId',
        name: '头条账号看板',
        component: () => import('../views/ToutiaoAccountBoard.vue'),
      },
      {
        path: 'data-analytics/baijiahao/:accountId',
        name: '百家号账号看板',
        component: () => import('../views/BaijiahaoAccountBoard.vue'),
      },
      {
        path: 'data-analytics/xhs/:accountId',
        name: '小红书账号看板',
        component: XhsAccountBoard,
      },
      {
        path: 'data-analytics/xhs/:accountId/notes/:noteId',
        name: '小红书作品看板',
        component: XhsNoteBoard,
      },

      // 选题（发现 / 素材 / 话题池）
      {
        path: 'discover',
        component: SectionHub,
        props: { sectionKey: 'discover', wide: true },
        children: [
          { path: '', redirect: { name: '小红书发现' } },
          { path: 'xhs', name: '小红书发现', component: XhsNoteDiscovery },
          { path: 'douyin', name: '抖音发现', component: DouyinDiscovery },
          { path: 'library', name: '发现库', component: DiscoveryLibrary },
          { path: 'xhs-comments', name: '评论监控', component: XhsCommentMonitor },
          { path: 'topic-pool', name: '话题池', component: TopicPoolSettings },
          // 旧路径
          { path: 'xhs-library', redirect: { path: '/discover/library', query: { platform: 'xiaohongshu' } } },
          { path: 'douyin-library', redirect: { path: '/discover/library', query: { platform: 'douyin' } } },
          { path: 'workbench', redirect: '/content/workbench' },
          { path: 'ops', redirect: '/automation/strategy' },
          { path: 'calendar', redirect: '/content/calendar' },
        ],
      },

      // 自动化（账号策略 / 定时调研 / 选题流程）
      { path: 'automation', redirect: '/automation/strategy' },
      { path: 'automation/strategy', name: '策略与定时', component: ContentOpsAgent },

      {
        path: 'settings',
        component: SectionHub,
        props: { sectionKey: 'settings' },
        children: [
          { path: '', redirect: { name: '系统设置' } },
          { path: 'system', name: '系统设置', component: Settings },
          { path: 'prompts', name: '提示词管理', component: Prompts },
          { path: 'prompt-lab', name: '提示词实验室', component: PromptLab },
          { path: 'devices', name: '设备与号码', component: DevicesSettings },
          { path: 'sms', name: '短信网关', component: SmsGateway, props: { embedded: true } },
          { path: 'topic-pool', redirect: '/discover/topic-pool' },
        ],
      },

      // 旧入口兼容
      { path: 'history', redirect: '/content/library' },
      { path: 'tasks', redirect: '/content/tasks' },
      { path: 'generate', redirect: '/create/generate' },
      { path: 'zhihu-qa', redirect: '/create/zhihu-qa' },
      { path: 'column-oral', redirect: '/create/column-oral' },
      { path: 'voice2video', redirect: '/create/voice2video' },
      { path: 'bilibili-rewrite', redirect: '/create/rewrite/bilibili' },
      { path: 'douyin-rewrite', redirect: '/create/rewrite/douyin' },
      { path: 'rewrite', redirect: '/create/rewrite/text' },
      { path: 'tabstory', redirect: '/create/tabstory' },
      { path: 'xhs-discovery', redirect: '/discover/xhs' },
      { path: 'xhs-discovery-library', redirect: { path: '/discover/library', query: { platform: 'xiaohongshu' } } },
      { path: 'douyin-discovery', redirect: '/discover/douyin' },
      { path: 'douyin-discovery-library', redirect: { path: '/discover/library', query: { platform: 'douyin' } } },
      { path: 'prompts', redirect: '/settings/prompts' },
      { path: 'prompt-lab', redirect: '/settings/prompt-lab' },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(APP_BASE ? `${APP_BASE}/` : '/'),
  routes,
})

export default router
